export interface NAICSCodeMapping {
  displayName: string;
  code: string;
  level: number; // 2, 3, 4, 5, or 6 digit level
}

// Import NAICS codes from JSON file
const naicsData = require("../data/naics_codes_for_app.json");

// Type the imported data
export const NAICS_CODE_MAPPINGS: NAICSCodeMapping[] =
  naicsData as NAICSCodeMapping[];

// Helper functions for working with NAICS codes
export const getNAICSCodesByLevel = (level: number): NAICSCodeMapping[] => {
  return NAICS_CODE_MAPPINGS.filter((mapping) => mapping.level === level);
};

// Note: sector field removed from interface, function disabled
// export const getNAICSCodesBySector = (sector: string): NAICSCodeMapping[] => {
//   return NAICS_CODE_MAPPINGS.filter(mapping => mapping.sector === sector);
// };

export const findNAICSCodeByCode = (
  code: string
): NAICSCodeMapping | undefined => {
  return NAICS_CODE_MAPPINGS.find((mapping) => mapping.code === code);
};

export const findNAICSCodesByPrefix = (prefix: string): NAICSCodeMapping[] => {
  return NAICS_CODE_MAPPINGS.filter((mapping) =>
    mapping.code.startsWith(prefix)
  );
};

// Note: sector field removed from interface, function disabled
// export const getNAICSSectors = (): string[] => {
//   return Array.from(new Set(NAICS_CODE_MAPPINGS.map(mapping => mapping.sector)));
// };

// Convert display names to database codes for filtering
export const convertNAICSDisplayNamesToCodes = (
  displayNames: string[]
): string[] => {
  return displayNames
    .map(
      (displayName) =>
        NAICS_CODE_MAPPINGS.find(
          (mapping) => mapping.displayName === displayName
        )?.code
    )
    .filter((code): code is string => code !== undefined);
};

// Convert database codes to display names for UI
export const convertNAICScCodesToDisplayNames = (codes: string[]): string[] => {
  return codes
    .map(
      (code) =>
        NAICS_CODE_MAPPINGS.find((mapping) => mapping.code === code)
          ?.displayName
    )
    .filter((displayName): displayName is string => displayName !== undefined);
};
